<template>
  <div class="notification-detail">
    <NotificationDetailSkeleton v-if="loading" />

    <template v-if="!loading && item">
      <div v-if="showBack" class="notification-detail__back" @click="$emit('back')">
        <i class="uil-arrow-left"></i>
        <span>{{ $t('general.back') }}</span>
      </div>

      <div class="notification-detail__header">
        <h3 class="notification-detail__title">
          <template v-if="typeof item.parsed_data.message !== 'undefined'">
            {{ item.parsed_data.message }}
          </template>
        </h3>
        <span class="notification-detail__date">
          <i class="uil-calendar-alt"></i>
          {{ formattedDate }}
        </span>
      </div>

      <div class="notification-detail__divider"></div>

      <div class="notification-detail__body">
        <template v-if="typeof item.parsed_data.text !== 'undefined'">
          <div v-html="item.parsed_data.text"></div>
        </template>
      </div>
    </template>

    <div v-if="!loading && !item" class="notification-detail__empty">
      <i class="uil-bell"></i>
      <p>{{ $t('general.select_notification') }}</p>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import 'moment/locale/fr';
import 'moment/locale/es';
import 'moment/locale/az';
import 'moment/locale/tr';
import 'moment/locale/en-gb';
import NotificationDetailSkeleton from "./NotificationDetailSkeleton.vue";

export default {
  name: "NotificationDetailPanel",
  components: {
    NotificationDetailSkeleton,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showBack: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formattedDate() {
      if (!this.item) return '';
      return moment(this.item.created_at)
          .locale(this.secureLocalStorage("language"))
          .format('DD MMMM YYYY');
    },
  },
};
</script>

<style scoped>
.notification-detail {
  flex: 1;
  min-width: 0;
  background: #fff;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  padding: 28px;
  min-height: 400px;
  display: flex;
  flex-direction: column;
}

.notification-detail__back {
  display: none;
  align-items: center;
  gap: 6px;
  color: #2563eb;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-bottom: 16px;
  transition: color 0.2s ease;
}

.notification-detail__back:hover {
  color: #1d4ed8;
}

.notification-detail__back i {
  font-size: 18px;
}

.notification-detail__header {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.notification-detail__title {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  line-height: 1.4;
}

.notification-detail__date {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #94a3b8;
  font-weight: 400;
}

.notification-detail__date i {
  font-size: 15px;
}

.notification-detail__divider {
  height: 1px;
  background: #e2e8f0;
  margin: 20px 0;
}

.notification-detail__body {
  font-size: 15px;
  color: #475569;
  line-height: 1.7;
  flex: 1;
}

.notification-detail__body :deep(a) {
  color: #2563eb;
  text-decoration: none;
}

.notification-detail__body :deep(a:hover) {
  text-decoration: underline;
}

.notification-detail__empty {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #94a3b8;
}

.notification-detail__empty i {
  font-size: 48px;
  opacity: 0.4;
}

.notification-detail__empty p {
  font-size: 15px;
  margin: 0;
}

@media (max-width: 960px) {
  .notification-detail {
    padding: 20px;
  }

  .notification-detail__title {
    font-size: 16px;
  }
}

@media (max-width: 768px) {
  .notification-detail__back {
    display: inline-flex;
  }

  .notification-detail {
    border-radius: 0;
    border: none;
    min-height: auto;
  }
}

@media (max-width: 480px) {
  .notification-detail {
    padding: 16px;
  }

  .notification-detail__title {
    font-size: 15px;
  }

  .notification-detail__body {
    font-size: 13px;
  }

  .notification-detail__empty i {
    font-size: 36px;
  }

  .notification-detail__empty p {
    font-size: 13px;
  }
}

@media (max-width: 768px) {
  .notification-detail__back {
    min-height: 44px;
    padding: 10px 0;
  }

  .notification-detail__title {
    font-size: 18px;
    line-height: 1.4;
    overflow-wrap: anywhere;
  }

  .notification-detail__body {
    font-size: 14px;
    line-height: 1.6;
    overflow-wrap: anywhere;
  }

  .notification-detail__body :deep(img),
  .notification-detail__body :deep(table),
  .notification-detail__body :deep(iframe) {
    max-width: 100%;
  }
}
</style>
